import React from 'react';
import Bugsnag, { Event } from '@bugsnag/js';
import BugsnagPluginReact, {
  BugsnagErrorBoundary as BugsnagErrorBoundaryType,
} from '@bugsnag/plugin-react';
import { BUGSNAG_API_KEY } from '../config/constants';
import { DOCKER_IMAGE_TAG, ENVIRONMENT } from '../config/environment';
import { userSelector } from '../data/selectors/authSelectors';
import { store } from '../config/store';

interface ExtendedEvent extends Event {
  originalError: Error | undefined;
}

const handleClientError = async (event: ExtendedEvent) => {
  console.debug('Trying to send error to Bugsnag:', event);
  const state = store.getState();
  const user = userSelector(state);

  /* Misc */
  if (user) {
    event.setUser(user.id, user.email);
  }
};

Bugsnag.start({
  apiKey: BUGSNAG_API_KEY,
  appVersion: DOCKER_IMAGE_TAG || 'development',
  releaseStage: ENVIRONMENT === 'production' ? 'production' : 'development',
  plugins: [new BugsnagPluginReact()],
  onError: handleClientError,
});

const ReactPlugin = Bugsnag.getPlugin('react');
export const BugsnagErrorBoundary = ReactPlugin?.createErrorBoundary(
  React
) as BugsnagErrorBoundaryType;
